import React, { Component } from "react";
import appleStoreBadge from "../assets/badges/apple-store-badge.svg";
import googlePlayBadge from "../assets/badges/google-play-badge.svg";

class AppsSectionSingle extends Component {
  render() {
    const { app, language, t } = this.props;

    if (!app) {
      return null;
    }

    return (
      <section className="section apps-section apps-section-single" id="apps">
        <div className="section-head">
          <h2>{t("sections.publishedSingleTitle")}</h2>
        </div>
        <article className="single-card">
          <div className="single-content">
            <div className="single-visual">
              {app.logoPath && (
                <div className="card-logo">
                  <img
                    src={app.logoPath}
                    alt={`${app.name} logo`}
                    className="app-logo"
                  />
                </div>
              )}
              <div>
                <span className="chip">
                  {(app.category && app.category[language]) || app.category}
                </span>
                {app.detailPath ? (
                  <a href={app.detailPath} className="app-title-link">
                    <h3>{app.name}</h3>
                  </a>
                ) : (
                  <h3>{app.name}</h3>
                )}
                <span className="platform">{app.platform}</span>
              </div>
            </div>
            <p>
              {(app.description && app.description[language]) || app.description}
            </p>
            <div className="card-bottom">
              <span className="tag">
                {(app.tag && app.tag[language]) || app.tag}
              </span>
              <div className="store-badges">
                {app.appStoreUrl && (
                  <a
                    className="store-badge"
                    href={app.appStoreUrl}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src={appleStoreBadge} alt="App Store" />
                  </a>
                )}
                {app.googlePlayUrl && (
                  <a
                    className="store-badge"
                    href={app.googlePlayUrl}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src={googlePlayBadge} alt="Google Play" />
                  </a>
                )}
              </div>
            </div>
          </div>
          {app.mockupPath && (
            <div className="single-mockup">
              <img src={app.mockupPath} alt={`${app.name} home screen mockup`} />
            </div>
          )}
        </article>
      </section>
    );
  }
}

export default AppsSectionSingle;
